var map = {
	"./1900-walt-disney.webp": "./src/assets/images/origins/walt-disney-imagineering/1900-walt-disney.webp",
	"./1908-john-hench.webp": "./src/assets/images/origins/walt-disney-imagineering/1908-john-hench.webp",
	"./1910-bill-evans.webp": "./src/assets/images/origins/walt-disney-imagineering/1910-bill-evans.webp",
	"./1910-dorothea-redmond.webp": "./src/assets/images/origins/walt-disney-imagineering/1910-dorothea-redmond.webp",
	"./1911-harper-goff.webp": "./src/assets/images/origins/walt-disney-imagineering/1911-harper-goff.webp",
	"./1911-mary-blair.webp": "./src/assets/images/origins/walt-disney-imagineering/1911-mary-blair.webp",
	"./1913-claude-coats.webp": "./src/assets/images/origins/walt-disney-imagineering/1913-claude-coats.webp",
	"./1913-marc-davis.webp": "./src/assets/images/origins/walt-disney-imagineering/1913-marc-davis.webp",
	"./1915-ken-obrien.webp": "./src/assets/images/origins/walt-disney-imagineering/1915-ken-obrien.webp",
	"./1918-blaine-gibson.webp": "./src/assets/images/origins/walt-disney-imagineering/1918-blaine-gibson.webp",
	"./1919-x-atencio.webp": "./src/assets/images/origins/walt-disney-imagineering/1919-x-atencio.webp",
	"./1925-leota-toombs.webp": "./src/assets/images/origins/walt-disney-imagineering/1925-leota-toombs.webp",
	"./1929-alice-davis.webp": "./src/assets/images/origins/walt-disney-imagineering/1929-alice-davis.webp",
	"./1930-chuck-abbott.webp": "./src/assets/images/origins/walt-disney-imagineering/1930-chuck-abbott.webp",
	"./1930-rolly-crump.webp": "./src/assets/images/origins/walt-disney-imagineering/1930-rolly-crump.webp",
	"./1934-martysklar.webp": "./src/assets/images/origins/walt-disney-imagineering/1934-martysklar.webp",
	"./1934-michael-graves.webp": "./src/assets/images/origins/walt-disney-imagineering/1934-michael-graves.webp",
	"./1937-carl-bongirno.webp": "./src/assets/images/origins/walt-disney-imagineering/1937-carl-bongirno.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/origins/walt-disney-imagineering sync ^\\.\\/.*$";